import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'shrimp-off',
  size: 24,
  node: [
    [
      'path',
      { d: 'M10 2a3.28 3.28 0 003.227 1.798l6.17-.561A1 1 0 1119.614 8H13.5', key: '1y5dzy' },
    ],
    ['path', { d: 'M11 20c-.5.5-1.12 1-2.5 1a1 1 0 010-5H12a7 7 0 003.283-.817', key: 'rkxng5' }],
    [
      'path',
      {
        d: 'M11 22c-.5-.5-1.12-1-2.5-1a6.5 6.5 0 01-5.63-3.25 6.44 6.44 0 015.236-9.744',
        key: '1arf7n',
      },
    ],
    ['path', { d: 'M18.04 12.54A7 7 0 0019 9V8', key: '10qvq6' }],
    ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
    ['path', { d: 'M8 16c-2 0-4.5-4-4-6', key: '1f5g8v' }],
    ['path', { d: 'M9.43 9.33A8.5 8.5 0 0010 16', key: '1wfq5e' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ShrimpOff
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMmEzLjI4IDMuMjggMCAwMDMuMjI3IDEuNzk4bDYuMTctLjU2MUExIDEgMCAxMTE5LjYxNCA4SDEzLjUiIC8+CiAgPHBhdGggZD0iTTExIDIwYy0uNS41LTEuMTIgMS0yLjUgMWExIDEgMCAwMTAtNUgxMmE3IDcgMCAwMDMuMjgzLS44MTciIC8+CiAgPHBhdGggZD0iTTExIDIyYy0uNS0uNS0xLjEyLTEtMi41LTFhNi41IDYuNSAwIDAxLTUuNjMtMy4yNSA2LjQ0IDYuNDQgMCAwMTUuMjM2LTkuNzQ0IiAvPgogIDxwYXRoIGQ9Ik0xOC4wNCAxMi41NEE3IDcgMCAwMDE5IDlWOCIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Ik04IDE2Yy0yIDAtNC41LTQtNC02IiAvPgogIDxwYXRoIGQ9Ik05LjQzIDkuMzNBOC41IDguNSAwIDAwMTAgMTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/shrimp-off
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShrimpOff = createLucideIcon(__iconData);

export default ShrimpOff;
